import React from 'react'
import { getOrderHistory } from 'client/utils/api-routes-orders'
import {
  DcDiv,
  DcText,
  PixelDate,
  PixelTable,
  Section,
  SectionContent,
  SectionHeader,
} from 'pixel-base'
import styled from 'styled-components'
import { OrderDetail } from '../../../../../../decl.d'

const historyColumns = [
  {
    dataKey: 'date',
    name: 'Date',
    sortable: true,
    width: '40%',

    selector: (row) => <PixelDate value={row.date} format={'pixelStandard'} />,
  },
  {
    dataKey: 'order_id',
    name: 'Order ID',
    sortable: true,
    selector: (row) => row.order_id,
  },
  {
    dataKey: 'status',
    name: 'Status ',
    sortable: true,
    selector: (row) => row.status,
  },
  {
    dataKey: 'total',
    name: 'Total',
    sortable: true,
    selector: (row) => row.total,
  },
]

interface IProps {
  details: OrderDetail
  detailID: number
}
const SummaryTable = (props: IProps) => {
  const { details, detailID } = props
  const [orderHistory, setOrderHistory] = React.useState<any>([])
  const [orderSummary, setorderSummary] = React.useState([])

  const fetchOrderHistory = (detailID, productID) => {
    // setTableLoading(true)
    getOrderHistory(detailID, productID).subscribe((res: any) => {
      // setTableLoading(false)
      const summaryData: any = []

      const data = JSON.parse(res.response.summary[0].customer_order_history)
      data?.Counts.forEach((d, i) => {
        d.data_type = 'Counts'
        const revenue = data.revenue[i]
        revenue.data_type = 'Revenue'
        summaryData.push(d)
        summaryData.push(revenue)
      })

      setOrderHistory(data.order_history)

      setorderSummary(summaryData)
    })
  }
  React.useEffect(() => {
    fetchOrderHistory(detailID, details?.customer_id)
  }, [details])
  return (
    <Container>
      <Section noPadding>
        <SectionHeader>Summary</SectionHeader>
        <SectionContent>
          <DcDiv width="100%">
            <DcDiv style={{ color: '#8e959b', fontWeight: '400' }} width="auto">
              <DcText
                style={{
                  width: 'auto',
                  color: '#8e959b',
                  fontWeight: '600',
                }}
              >
                Orders Count :
              </DcText>
            </DcDiv>
            <DcDiv style={{ color: '#8e959b', fontWeight: '400' }} width="auto">
              {orderSummary[0]?.total}
            </DcDiv>
            <DcDiv style={{ color: '#8e959b', fontWeight: '400' }} width="auto">
              <DcText
                style={{
                  width: 'auto',
                  color: '#8e959b',
                  fontWeight: '600',
                }}
              >
                Revenue :
              </DcText>
            </DcDiv>
            <DcDiv
              style={{ color: '#8e959b', fontWeight: '400', width: 'auto' }}
              width="auto"
            >
              {orderSummary[1]?.total}
            </DcDiv>
          </DcDiv>
        </SectionContent>
      </Section>
      <Section noPadding>
        <SectionHeader>Order history</SectionHeader>
        <SectionContent noPadding>
          <PixelTable
            columns={historyColumns}
            data={orderHistory}
            pagination={false}
          />
        </SectionContent>
      </Section>
    </Container>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  height: auto;
  max-height: calc(100vh - 230px);
  overflow: auto;
`

export default SummaryTable
